/* 只在购物车使用标准结账入口；折扣由 Shopify 校验和计算。 */
(() => {
  if (window.luminaCartCheckoutReady) return;
  window.luminaCartCheckoutReady = true;
  const selector = '#CartDrawer-Checkout, #checkout.cart__checkout-button';
  const originals = new WeakMap();
  let pending = false;
  const root = window.Shopify?.routes?.root || '/';

  function restore() {
    pending = false;
    document.querySelectorAll(`${selector}`).forEach((button) => {
      if (!button.dataset.lqCheckoutBusy) return;
      button.innerHTML = originals.get(button) || 'Secure checkout';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      delete button.dataset.lqCheckoutBusy;
    });
  }

  async function readCart(path, options) {
    const response = await fetch(root + path, options);
    if (!response.ok) throw new Error('购物车请求失败');
    return response.json();
  }

  async function tidyPersonalization(cart) {
    // 原型与赠品信息保留在订单后台，结账页只显示实际购买的款式。
    let latest = cart;
    for (let remaining = cart.items.length; remaining > 0; remaining -= 1) {
      // 每次读取最新行键，兼容 Shopify 合并相同款式或重新计算折扣。
      const item = latest.items.find(line => line.product_id === 9626240811196 &&
        ['Personal Archetype', 'VIP Inclusions'].some(key => Object.hasOwn(line.properties || {}, key) &&
          (!Object.hasOwn(line.properties, '_' + key) || line.properties['_' + key] === line.properties[key])));
      if (!item) break;
      const properties = { ...item.properties };
      let changed = false;
      for (const key of ['Personal Archetype', 'VIP Inclusions']) {
        const hidden = '_' + key;
        if (Object.hasOwn(properties, key) && (!Object.hasOwn(properties, hidden) || properties[hidden] === properties[key])) {
          properties[hidden] = properties[key];
          delete properties[key];
          changed = true;
        }
      }
      if (changed) {
        latest = await readCart('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
        });
      }
    }
    return latest;
  }

  async function checkout(event) {
    const button = event.type === 'submit' ? event.submitter : event.target.closest(selector);
    if (!button?.matches(selector) || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    originals.set(button, button.innerHTML);
    button.dataset.lqCheckoutBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Opening secure checkout…';

    try {
      let cart = await readCart('cart.js');
      if (!cart.item_count) {
        restore();
        return;
      }
      try {
        cart = await tidyPersonalization(cart);
      } catch (error) {
        // 资料整理失败时保留原记录，仍允许顾客继续原生结账。
        console.warn('结账资料保持原样。');
      }
      const physicalCount = cart.items.reduce((sum, item) => sum + (item.requires_shipping ? item.quantity : 0), 0);
      const hasCode = (cart.discount_codes || []).length > 0;
      // 保留已存在的折扣与自动阶梯优惠，只为尚无优惠的单件实体商品验证欢迎码。
      if (physicalCount === 1 && cart.total_discount === 0 && !hasCode) {
        await readCart('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: 'WELCOME10' }),
        });
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      restore();
      let message = document.getElementById('lumina-checkout-error');
      if (!message) {
        message = document.createElement('p');
        message.id = 'lumina-checkout-error';
        message.setAttribute('role', 'alert');
        button.insertAdjacentElement('afterend', message);
      }
      message.textContent = 'Please try again. Your cart is saved.';
    }
  }

  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  window.addEventListener('pageshow', restore);
})();
